import { combineReducers } from "redux";

import alert from "./alert";
import modal from "./modal";
import auth from "./auth";
import admin from "./admin";
import user from "./user";

const rootReducer = combineReducers({
    alert,
    modal,
    auth,
    admin,
    user
});

export default rootReducer;
